import { createSelector } from 'reselect';

import getSelectors from '../../shared/store/selectorsFactory';
import { adminPageNames } from '../../shared/adminPageNames';

export const sharedSelectors = getSelectors(adminPageNames.ADMIN_TAX_ENTRY_SETTINGS);

export const taxEntriesSelector = ({ administration }) =>
  administration[adminPageNames.ADMIN_TAX_ENTRY_SETTINGS].entities;

export const fetchingDataForModalSelector = state =>
  state.administration[adminPageNames.ADMIN_TAX_ENTRY_SETTINGS].isFetchingInitialDataForAddModal;

export const typeOptionsSelector = createSelector(
  state => state.administration[adminPageNames.ADMIN_TAX_ENTRY_SETTINGS].typeValues,
  typeValues =>
    typeValues.map(({ name, value }) => ({ label: value, value, desc: name }))
);

export const activityOptionsSelector = createSelector(
  state => state.administration[adminPageNames.ADMIN_TAX_ENTRY_SETTINGS].activityValues,
  activityValues => activityValues.map(({ name, value }) => ({ label: value, value, desc: name }))
);

export const allowTopsideOptionsSelector = createSelector(
  state => state.administration[adminPageNames.ADMIN_TAX_ENTRY_SETTINGS].allowTopsideValues,
  allowTopsideValues => allowTopsideValues.map(({ value }) => ({ label: value, value }))
);

export const slViewOptionsSelector = createSelector(
  state => state.administration[adminPageNames.ADMIN_TAX_ENTRY_SETTINGS].slViewValues,
  slViewValues => slViewValues.map(({ value }) => ({ label: value, value }))
);

export const allowEntryOptionsSelector = createSelector(
  state => state.administration[adminPageNames.ADMIN_TAX_ENTRY_SETTINGS].allowEntryValues,
  allowEntryValues => allowEntryValues.map(({ value }) => ({ label: value, value }))
);

export const allowTransferOptionsSelector = createSelector(
  state => state.administration[adminPageNames.ADMIN_TAX_ENTRY_SETTINGS].allowTransferValues,
  allowTransferValues => allowTransferValues.map(({ value }) => ({ label: value, value }))
);

export const derivedDataForImportSelector = createSelector(
  typeOptionsSelector,
  activityOptionsSelector,
  (types, activities) => ({ types, activities })
);
